import { createContext, useContext, useEffect, useState, createElement } from "react";

const ru = {
  nav: { about: "О компании", product: "Продукт", cases: "Применение", economics: "Экономика", faq: "Вопросы", contacts: "Контакты", cta: "Оставить заявку", menu: "Меню", presentation: "Презентация" },
  pres: {
    title: "Презентация", sub: "Введите 4-значный код доступа", checking: "Проверяем…", loading: "Загружаем презентацию…", close: "Закрыть",
    wrong: "Неверный код. Осталось попыток: {n}", locked: "Слишком много неверных попыток. Попробуйте через {m} мин.", error: "Не удалось открыть презентацию. Попробуйте ещё раз.",
  },
  hero: {
    eyebrow: "Официальный партнёр QAZAQNET · Единственный представитель в СНГ",
    company: "ТОО «БАСПАНА ҚҰРЫЛЫС ИНВЕСТ»",
    lines: ["Строим", "цифровое", "будущее", "страны"],
    sub: "ТОО «БАСПАНА ҚҰРЫЛЫС ИНВЕСТ» из Актау представляет интернет-хабы QAZAQNET Wi-Fi 7 — высокоскоростной беспроводной интернет для аулов Мангистау, городов и промышленных зон без прокладки оптоволокна.",
    cta1: "Оставить заявку",
    cta2: "Реквизиты компании",
    chip: "Wi-Fi 7 · покрытие 360°",
    scroll: "Листайте",
    stats: [
      { v: "56", u: "Гбит/с", l: "пропускная способность хаба" },
      { v: "4 600+", u: "", l: "подключений к одному хабу" },
      { v: "1", u: "день", l: "на установку" },
      { v: "3", u: "года", l: "гарантии" },
    ],
  },
  marquee: ["Единственный представитель QAZAQNET в СНГ", "Мангистау · Каспий · Устюрт", "Wi-Fi 7 · 56 Гбит/с на один хаб", "Установка за 1 день", "IP67 · −40…+65 °C", "Гарантия 3 года", "Без земляных работ и оптоволокна", "MESH: до 12 хабов"],
  about: {
    label: "О компании",
    title: "Соединяем Казахстан — от Актау до каждого аула.",
    p1: "ТОО «БАСПАНА ҚҰРЫЛЫС ИНВЕСТ» — официальный партнёр и единственный представитель QAZAQNET в странах СНГ. Через нас предприниматели, акиматы и инициативные жители получают доступ к оборудованию QAZAQNET и сопровождение на каждом шаге.",
    p2: "Качественная цифровая связь — не роскошь, а основа для образования, здоровья и развития бизнеса.",
    director: "Руководство",
    name: "Бурыбаев Актан Довлетович",
    role: "Директор",
    facts: [
      { k: "Статус", v: "Официальный партнёр QAZAQNET" },
      { k: "Территория", v: "Страны СНГ" },
      { k: "Офис", v: "Актау, Мангистауская обл." },
    ],
  },
  region: {
    label: "Мангистау",
    title: "Мангистау — наша земля",
    text: "Земля нефтяных месторождений, ставших богатством всего Казахстана, белых скал Бозжыры, Каспийского побережья и легендарных адайских скакунов. Наш дом — Актау, поэтому цифровую связь мы начинаем с родного края: от берегов Каспия до самых дальних аулов Устюрта.",
    quote: "Мангистау — сокровищница Казахстана",
    facts: [
      { v: "Нефть", l: "богатство всего Казахстана" },
      { v: "Каспий", l: "морские ворота Казахстана" },
      { v: "Адайский скакун", l: "гордость нашего края" },
    ],
  },
  product: {
    label: "Продукт",
    title: "QAZAQNET Hub — Wi-Fi 7 для целого посёлка в одном корпусе",
    hub: { t: "Интернет-хаб QAZAQNET", d: "Устанавливается на вышку, крышу, водонапорную башню или столб и раздаёт интернет на сотни домов и тысячи пользователей." },
    speed: { v: "56 Гбит/с", t: "пропускная способность одного хаба", d: "Wi-Fi 7, три радиомодуля: одновременная передача в трёх диапазонах — скорость выше до 2,4 раза, задержка ниже на 75%." },
    users: { v: "4 600+", t: "одновременных подключений", d: "Технология MU-MIMO: до 16 пространственных потоков." },
    ip: { v: "IP67", t: "−40…+65 °C", d: "Выдерживает град диаметром до 40 мм. Корпус из алюминия и полимера." },
    mesh: { v: "MESH", t: "до 12 хабов в одной сети", d: "Объединяйте хабы в единую сеть района или региона без перестройки инфраструктуры." },
    cpe: { v: "0", t: "дополнительного оборудования у абонента", d: "Смартфон, ноутбук, телевизор — подключение как к обычному Wi-Fi." },
    day: { v: "1 день", t: "монтаж и настройка", d: "Без земляных работ и прокладки оптоволокна." },
  },
  cases: {
    label: "Применение",
    title: "Где работает хаб",
    items: [
      { t: "Аулы и посёлки", d: "Гигабитный интернет для отдалённых аулов Мангистау и Устюрта — дома, школы, больницы подключены к цифровому миру." },
      { t: "Города", d: "Wi-Fi-покрытие для микрорайонов, набережных, парков и бизнес-центров — как в Актау на берегу Каспия. Поддерживает более 5 000 абонентов." },
      { t: "Промышленные зоны", d: "Надёжная связь для нефтяных месторождений, карьеров и строек — для техники, IoT-датчиков и рабочих." },
    ],
  },
  steps: {
    label: "Запуск",
    title: "Четыре шага до интернета",
    items: [
      { t: "Установка на возвышенность", d: "Вышка, крыша, водонапорная башня или столб." },
      { t: "Подключение к магистральному каналу", d: "Оптоволокно или другой магистральный канал — хаб сразу готов к работе." },
      { t: "Настройка секторов", d: "Распределение абонентов по секторам и каналам." },
      { t: "Подключение абонентов", d: "Жители подключаются к Wi-Fi и оплачивают тариф." },
    ],
  },
  econ: {
    label: "Экономика",
    title: "Готовый бизнес-модуль",
    lead: "Один хаб — стабильный доход. Посчитайте модель для своего населённого пункта.",
    subs: "Количество абонентов",
    tariff: "Тариф, ₸ / мес",
    gross: "Выручка в месяц",
    costs: "Расходы: электроэнергия, канал связи, налог 3%",
    net: "Чистая прибыль в месяц",
    year: "Чистая прибыль в год",
    note: "Расчёт носит условный характер и приведён для предварительной оценки. Фактические показатели зависят от тарифов, числа абонентов, стоимости электроэнергии и канала связи, налогового режима и других факторов.",
  },
  warranty: {
    label: "Гарантия",
    title: "Официальная гарантия — 3 года",
    d: "Любая неисправность устраняется без оплаты за диагностику, работу и детали.",
    unit: "года",
    ring: "ГАРАНТИЯ · 3 ГОДА · QAZAQNET · ",
    points: ["Бесплатный ремонт или полная замена блока", "Действует на все интернет-хабы", "Исключение — только повреждения по вине человека", "Гарантию можно продлить"],
  },
  faq: {
    label: "Вопросы",
    title: "Честные ответы",
    items: [
      { q: "Это законно? Нужна ли лицензия?", a: "Да, деятельность полностью легальна. Для оказания услуг связи в Казахстане необходима регистрация в качестве оператора — процедура стандартная и доступна как ИП, так и ТОО. Партнёров сопровождают на каждом шаге оформления документов." },
      { q: "В ауле нет оптоволокна и вышек. Хаб будет работать?", a: "Да. Достаточно одной точки подключения к магистральному каналу — дальше хаб раздаёт интернет по воздуху на весь населённый пункт. Его можно установить на любой возвышенности: вышке, крыше, водонапорной башне или столбе." },
      { q: "Кто обслуживает оборудование?", a: "Хаб контролируется удалённо 24/7, большинство вопросов решается без выезда специалиста. В конструкции нет движущихся частей, действует официальная гарантия 3 года." },
      { q: "Сколько времени занимает запуск?", a: "Монтаж и настройка одного хаба — в среднем 1 день при готовой точке установки и электропитании. Документы оформляются параллельно: от нескольких дней до пары недель." },
      { q: "Нужно ли жителям покупать роутеры или антенны?", a: "Нет. Хаб раздаёт Wi-Fi напрямую на устройства — от старых смартфонов с Wi-Fi 4 до новейших с Wi-Fi 7." },
    ],
  },
  contacts: { label: "Реквизиты и обратная связь", title: "Обсудим ваш проект", sub: "Оставьте контакты — мы свяжемся с вами и подберём решение для вашего населённого пункта." },
  form: {
    name: "Имя", phone: "Телефон", email: "Email (необязательно)", city: "Населённый пункт", message: "Сообщение",
    phName: "Как к вам обращаться", phCity: "Актау, Жанаозен, Бейнеу…", phMessage: "Расскажите о задаче",
    submit: "Отправить заявку", sending: "Отправляем…", ok: "Заявка отправлена! Мы свяжемся с вами в ближайшее время.", okTitle: "Спасибо!", again: "Отправить ещё",
    err: "Ошибка отправки. Попробуйте ещё раз.", required: "Укажите имя и телефон",
    consent: "Отправляя форму, вы соглашаетесь, что мы можем связаться с вами по указанным контактам.",
  },
  netmap: {
    label: "Карта покрытия", title: "Интерактивная карта покрытия нашей сети в городе Актау", sub: "Найдите свой микрорайон и посмотрите, где уже работают точки QAZAQNET и какую территорию они покрывают.",
    active: "Работает", planned: "В планах", radius: "Диаметр покрытия", m: "км", osm: "Картографические данные © участники",
    search: {
      placeholder: "Ваш адрес, например: 14 мкр, 5", btn: "Проверить", loading: "Ищем…",
      covered: "По этому адресу есть покрытие", coveredText: "Адрес в зоне точки «{hub}» — примерно {d} м от неё.",
      none: "Пока нет покрытия", noneText: "Ближайшая точка «{hub}» — в {d} км. Оставьте заявку, и мы сообщим, когда подключим ваш дом.",
      notFound: "Адрес не найден. Попробуйте формат «14 мкр, 5».", approx: "Точный дом не найден — проверен центр микрорайона.", cta: "Оставить заявку", ctaConnect: "Подключиться", city: "Актау",
    },
    example: "Расположение хабов показано для примера — скоро здесь будет актуальная карта сети.",
    reset: "Сбросить вид", zoomIn: "Приблизить", zoomOut: "Отдалить", allZones: "Все зоны", pickMd: "Выберите микрорайон",
    md: "мкр", mdFull: "микрорайон", coords: "Координаты", legend: "Цветовая легенда", hubsTitle: "Хабы QAZAQNET", landmarksTitle: "Достопримечательности",
    zones: {
      central: ["Микрорайоны 1–10", "Исторический центр города"],
      middle: ["Микрорайоны 11–20", "Коммерческие и жилые районы"],
      south: ["Микрорайоны 21–30", "Спальные районы"],
      new: ["Микрорайоны 31 и далее", "Новые районы, современная застройка"],
    },
    lm: {
      port: ["Морской порт", "главный порт Казахстана"],
      airport: ["Аэропорт", "международный аэропорт"],
      boulevard: ["Бульвар Победы", "прогулочный бульвар у моря"],
      theatre: ["Драматический театр", "культурный центр"],
      lighthouse: ["Маяк", "уникальный маяк на крыше дома"],
    },
  },
  req: {
    title: "Реквизиты",
    copy: "Скопировать", copied: "Скопировано", copyAll: "Скопировать все реквизиты",
    directorLabel: "Директор: Бурыбаев Актан Довлетович", call: "Позвонить",
    rows: [
      { k: "Наименование", v: "Товарищество с ограниченной ответственностью «БАСПАНА ҚҰРЫЛЫС ИНВЕСТ»" },
      { k: "БИН", v: "001140001806" },
      { k: "ИИК", v: "KZ45601A231000995651" },
      { k: "Банк", v: "АО «Народный Банк Казахстана»" },
      { k: "БИК", v: "HSBKKZKX" },
      { k: "Юр. адрес", v: "Мангистауская обл., г. Актау, 27 мкр, здание 85/1, каб. 101" },
      { k: "Email", v: "toobaspanakurylys@bk.ru" },
      { k: "Телефон", v: "+7 700 000 93 07" },
      { k: "Директор", v: "Бурыбаев Актан Довлетович" },
    ],
  },
  footer: { hq: "Адрес головного офиса:", rights: "Все права защищены.", company: "ТОО «БАСПАНА ҚҰРЫЛЫС ИНВЕСТ»", city: "Актау · Казахстан", partner: "Официальный партнёр и единственный представитель QAZAQNET в СНГ", source: "Информация о продукте: qazaqnet.kz", top: "Наверх" },
};

const kz = {
  nav: { about: "Компания", product: "Өнім", cases: "Қолдану", economics: "Экономика", faq: "Сұрақтар", contacts: "Байланыс", cta: "Өтінім қалдыру", menu: "Мәзір", presentation: "Презентация" },
  pres: {
    title: "Презентация", sub: "4 таңбалы қолжетімділік кодын енгізіңіз", checking: "Тексеріп жатырмыз…", loading: "Презентация жүктелуде…", close: "Жабу",
    wrong: "Код қате. Қалған әрекет саны: {n}", locked: "Қате әрекеттер тым көп. {m} минуттан кейін қайталап көріңіз.", error: "Презентацияны ашу мүмкін болмады. Қайталап көріңіз.",
  },
  hero: {
    eyebrow: "QAZAQNET ресми серіктесі · ТМД-дағы жалғыз өкілі",
    company: "«БАСПАНА ҚҰРЫЛЫС ИНВЕСТ» ЖШС",
    lines: ["Еліміздің", "цифрлық", "болашағын", "құрамыз"],
    sub: "Ақтаудағы «БАСПАНА ҚҰРЫЛЫС ИНВЕСТ» ЖШС QAZAQNET Wi-Fi 7 интернет-хабтарын ұсынады. Бұл — оптикалық талшық тартпай-ақ Маңғыстау ауылдарына, қалаларға және өнеркәсіптік аймақтарға жеткізілетін жоғары жылдамдықты сымсыз интернет.",
    cta1: "Өтінім қалдыру",
    cta2: "Компания деректемелері",
    chip: "Wi-Fi 7 · 360° қамту",
    scroll: "Төмен айналдырыңыз",
    stats: [
      { v: "56", u: "Гбит/с", l: "хабтың өткізу қабілеті" },
      { v: "4 600+", u: "", l: "бір хабқа қосылым" },
      { v: "1", u: "күн", l: "орнату уақыты" },
      { v: "3", u: "жыл", l: "кепілдік" },
    ],
  },
  marquee: ["QAZAQNET-тің ТМД-дағы жалғыз өкілі", "Маңғыстау · Каспий · Үстірт", "Wi-Fi 7 · бір хабқа 56 Гбит/с", "1 күнде орнату", "IP67 · −40…+65 °C", "3 жыл кепілдік", "Жер жұмыстарынсыз және оптикасыз", "MESH: 12 хабқа дейін"],
  about: {
    label: "Компания туралы",
    title: "Қазақстанды байланыстырамыз — Ақтаудан әр ауылға дейін.",
    p1: "«БАСПАНА ҚҰРЫЛЫС ИНВЕСТ» ЖШС — QAZAQNET компаниясының ТМД елдеріндегі ресми серіктесі және жалғыз өкілі. Біз арқылы кәсіпкерлер, әкімдіктер және белсенді тұрғындар QAZAQNET жабдығына қол жеткізіп, әр қадамда қолдау алады.",
    p2: "Сапалы цифрлық байланыс — сән-салтанат емес, білім беру, денсаулық сақтау және бизнесті дамытудың негізі.",
    director: "Басшылық",
    name: "Бурыбаев Актан Довлетович",
    role: "Директор",
    facts: [
      { k: "Мәртебе", v: "QAZAQNET ресми серіктесі" },
      { k: "Аумақ", v: "ТМД елдері" },
      { k: "Кеңсе", v: "Ақтау, Маңғыстау обл." },
    ],
  },
  region: {
    label: "Маңғыстау",
    title: "Маңғыстау — біздің өлке",
    text: "Маңғыстау — бүкіл Қазақстанның байлығына айналған мұнай кен орындарының, Бозжыраның ақ шыңдарының, Каспий жағалауының және атақты адай жылқысының мекені. Біздің үйіміз — Ақтау, сондықтан цифрлық байланысты туған өлкеден бастаймыз: Каспий жағалауынан Үстірттің ең шалғай ауылдарына дейін.",
    quote: "Маңғыстау — Қазақстанның қазынасы",
    facts: [
      { v: "Мұнай", l: "бүкіл Қазақстанның байлығы" },
      { v: "Каспий", l: "Қазақстанның теңіз қақпасы" },
      { v: "Адай жылқысы", l: "өлкеміздің мақтанышы" },
    ],
  },
  product: {
    label: "Өнім",
    title: "QAZAQNET Hub — бүкіл ауылды Wi-Fi 7-мен қамтитын бір құрылғы",
    hub: { t: "QAZAQNET интернет-хабы", d: "Мұнараға, шатырға, су мұнарасына немесе бағанға орнатылып, жүздеген үйлер мен мыңдаған пайдаланушыларға интернет таратады." },
    speed: { v: "56 Гбит/с", t: "бір хабтың өткізу қабілеті", d: "Wi-Fi 7, үш радиомодуль: үш диапазонда бір мезгілде тарату — жылдамдық 2,4 есеге дейін артады, кідіріс 75%-ға азаяды." },
    users: { v: "4 600+", t: "бір мезгілдегі қосылым", d: "MU-MIMO технологиясы: 16 кеңістіктік ағынға дейін." },
    ip: { v: "IP67", t: "−40…+65 °C", d: "Диаметрі 40 мм-ге дейінгі бұршаққа төтеп береді. Корпусы алюминий мен полимерден жасалған." },
    mesh: { v: "MESH", t: "бір желіде 12 хабқа дейін", d: "Инфрақұрылымды қайта құрмай-ақ хабтарды бүкіл аудан немесе өңір бойынша бір желіге біріктіріңіз." },
    cpe: { v: "0", t: "абонентке қажет қосымша жабдық", d: "Смартфон, ноутбук, теледидар — кәдімгі Wi-Fi-ға қосылғандай." },
    day: { v: "1 күн", t: "орнату және баптау", d: "Жер жұмыстарынсыз және оптикалық талшық тартпай-ақ." },
  },
  cases: {
    label: "Қолдану",
    title: "Хаб қайда жұмыс істейді",
    items: [
      { t: "Ауылдар мен кенттер", d: "Маңғыстау мен Үстірттің шалғай ауылдарына гигабитті интернет — үйлер, мектептер, ауруханалар цифрлық әлемге қосылады." },
      { t: "Қалалар", d: "Шағын аудандар, жағалаулар, саябақтар мен бизнес-орталықтар үшін Wi-Fi қамту — Каспий жағасындағы Ақтаудағыдай. 5 000-нан астам абонентті қолдайды." },
      { t: "Өнеркәсіптік аймақтар", d: "Мұнай кен орындары, карьерлер мен құрылыс алаңдары үшін сенімді байланыс — техника, IoT-датчиктер және жұмысшылар үшін." },
    ],
  },
  steps: {
    label: "Іске қосу",
    title: "Интернетке дейін төрт қадам",
    items: [
      { t: "Биіктікке орнату", d: "Мұнара, шатыр, су мұнарасы немесе баған." },
      { t: "Магистральдық арнаға қосу", d: "Оптикалық талшық немесе басқа магистральдық арна — хаб бірден жұмысқа дайын." },
      { t: "Секторларды баптау", d: "Абоненттерді секторлар мен арналарға бөлу." },
      { t: "Абоненттерді қосу", d: "Тұрғындар Wi-Fi-ға қосылып, тарифті төлейді." },
    ],
  },
  econ: {
    label: "Экономика",
    title: "Дайын бизнес-модуль",
    lead: "Бір хаб — тұрақты табыс. Өз елді мекеніңізге арналған модельді есептеңіз.",
    subs: "Абоненттер саны",
    tariff: "Тариф, ₸ / ай",
    gross: "Айлық түсім",
    costs: "Шығындар: электр энергиясы, байланыс арнасы, 3% салық",
    net: "Айлық таза пайда",
    year: "Жылдық таза пайда",
    note: "Есеп шартты сипатта және алдын ала бағалау үшін берілген. Нақты көрсеткіштер тарифке, абоненттер санына, электр энергиясы мен байланыс арнасының құнына, салық режиміне және басқа факторларға байланысты.",
  },
  warranty: {
    label: "Кепілдік",
    title: "Ресми кепілдік — 3 жыл",
    d: "Кез келген ақау диагностика, жұмыс және бөлшектер үшін ақы алынбай жойылады.",
    unit: "жыл",
    ring: "КЕПІЛДІК · 3 ЖЫЛ · QAZAQNET · ",
    points: ["Тегін жөндеу немесе блокты толық ауыстыру", "Барлық интернет-хабтарға қолданылады", "Ерекшелік — тек адамның кінәсінен болған зақымдар", "Кепілдікті ұзартуға болады"],
  },
  faq: {
    label: "Сұрақтар",
    title: "Адал жауаптар",
    items: [
      { q: "Бұл заңды ма? Лицензия қажет пе?", a: "Иә, қызмет толығымен заңды. Қазақстанда байланыс қызметтерін көрсету үшін оператор ретінде тіркелу қажет — бұл стандартты рәсім, оны ЖК де, ЖШС де өте алады. Серіктестер құжаттарды рәсімдеудің әр қадамында қолдау алады." },
      { q: "Ауылда оптика да, мұнара да жоқ. Хаб жұмыс істей ме?", a: "Иә. Магистральдық арнаға бір қосылу нүктесі жеткілікті — әрі қарай хаб интернетті ауа арқылы бүкіл елді мекенге таратады. Оны кез келген биіктікке орнатуға болады: мұнараға, шатырға, су мұнарасына немесе бағанға." },
      { q: "Жабдыққа кім қызмет көрсетеді?", a: "Хаб 24/7 қашықтан бақыланады, көптеген мәселелер маман шақырмай шешіледі. Құрылғыда қозғалмалы бөлшектер жоқ, ресми 3 жылдық кепілдік беріледі." },
      { q: "Іске қосу қанша уақыт алады?", a: "Дайын орнату нүктесі мен электр қуаты болса, бір хабты орнату және баптау орта есеппен 1 күн алады. Құжаттар қатар рәсімделеді: бірнеше күннен екі аптаға дейін." },
      { q: "Тұрғындарға роутер немесе антенна сатып алу керек пе?", a: "Жоқ. Хаб Wi-Fi-ды тікелей құрылғыларға таратады — Wi-Fi 4 қолдайтын ескі смартфондардан бастап Wi-Fi 7 қолдайтын ең жаңа құрылғыларға дейін." },
    ],
  },
  contacts: { label: "Деректемелер және кері байланыс", title: "Жобаңызды талқылайық", sub: "Байланыс деректеріңізді қалдырыңыз — біз сізбен хабарласып, елді мекеніңізге шешім таңдаймыз." },
  form: {
    name: "Атыңыз", phone: "Телефон", email: "Email (міндетті емес)", city: "Елді мекен", message: "Хабарлама",
    phName: "Сізді қалай атайық", phCity: "Ақтау, Жаңаөзен, Бейнеу…", phMessage: "Мақсатыңыз туралы қысқаша жазыңыз",
    submit: "Өтінімді жіберу", sending: "Жіберілуде…", ok: "Өтінім жіберілді! Жақын арада сізбен хабарласамыз.", okTitle: "Рақмет!", again: "Тағы жіберу",
    err: "Жіберу кезінде қате шықты. Қайталап көріңіз.", required: "Атыңыз бен телефон нөміріңізді көрсетіңіз",
    consent: "Форманы жібере отырып, көрсетілген байланыс деректері арқылы сізбен хабарласуымызға келісім бересіз.",
  },
  netmap: {
    label: "Қамту картасы", title: "Ақтау қаласындағы желіміздің қамту аймағының интерактивті картасы", sub: "Өз шағын ауданыңызды тауып, QAZAQNET нүктелері қай жерде жұмыс істейтінін және қандай аумақты қамтитынын көріңіз.",
    active: "Жұмыс істейді", planned: "Жоспарда", radius: "Қамту диаметрі", m: "км", osm: "Картографиялық деректер ©",
    search: {
      placeholder: "Мекенжайыңыз, мысалы: 14 ш/а, 5", btn: "Тексеру", loading: "Іздеп жатырмыз…",
      covered: "Бұл мекенжайда қамту бар", coveredText: "Мекенжай «{hub}» нүктесінің аймағында — одан шамамен {d} м.",
      none: "Әзірге қамту жоқ", noneText: "Ең жақын нүкте «{hub}» — {d} км жерде. Өтінім қалдырыңыз, үйіңізді қосқанда хабарлаймыз.",
      notFound: "Мекенжай табылмады. «14 ш/а, 5» форматында жазып көріңіз.", approx: "Нақты үй табылмады — шағын ауданның орталығы тексерілді.", cta: "Өтінім қалдыру", ctaConnect: "Қосылу", city: "Ақтау",
    },
    example: "Хабтардың орналасуы мысал ретінде көрсетілген — жақында мұнда желінің нақты картасы болады.",
    reset: "Бастапқы көрініс", zoomIn: "Жақындату", zoomOut: "Алыстату", allZones: "Барлық аймақтар", pickMd: "Шағын ауданды таңдаңыз",
    md: "ш/а", mdFull: "шағын аудан", coords: "Координаттар", legend: "Түстер белгісі", hubsTitle: "QAZAQNET хабтары", landmarksTitle: "Көрікті жерлер",
    zones: {
      central: ["1–10 шағын аудандар", "Қаланың тарихи орталығы"],
      middle: ["11–20 шағын аудандар", "Коммерциялық және тұрғын аудандар"],
      south: ["21–30 шағын аудандар", "Тұрғын аудандар"],
      new: ["31-ден бастап", "Жаңа аудандар, заманауи құрылыс"],
    },
    lm: {
      port: ["Теңіз порты", "Қазақстанның басты порты"],
      airport: ["Әуежай", "халықаралық әуежай"],
      boulevard: ["Жеңіс бульвары", "теңіз жағасындағы серуен бульвары"],
      theatre: ["Драма театры", "мәдени орталық"],
      lighthouse: ["Шамшырақ", "үй төбесіндегі бірегей шамшырақ"],
    },
  },
  req: {
    title: "Деректемелер",
    copy: "Көшіру", copied: "Көшірілді", copyAll: "Барлық деректемелерді көшіру",
    directorLabel: "Директор: Бурыбаев Актан Довлетович", call: "Қоңырау шалу",
    rows: [
      { k: "Атауы", v: "«БАСПАНА ҚҰРЫЛЫС ИНВЕСТ» жауапкершілігі шектеулі серіктестігі" },
      { k: "БСН", v: "001140001806" },
      { k: "ЖСК", v: "KZ45601A231000995651" },
      { k: "Банк", v: "«Қазақстан Халық Банкі» АҚ" },
      { k: "БСК", v: "HSBKKZKX" },
      { k: "Заңды мекенжай", v: "Маңғыстау облысы, Ақтау қ., 27 шағын аудан, 85/1 ғимарат, 101 кеңсе" },
      { k: "Email", v: "toobaspanakurylys@bk.ru" },
      { k: "Телефон", v: "+7 700 000 93 07" },
      { k: "Директор", v: "Бурыбаев Актан Довлетович" },
    ],
  },
  footer: { hq: "Бас кеңсенің мекенжайы:", rights: "Барлық құқықтар қорғалған.", company: "«БАСПАНА ҚҰРЫЛЫС ИНВЕСТ» ЖШС", city: "Ақтау · Қазақстан", partner: "QAZAQNET ресми серіктесі және ТМД-дағы жалғыз өкілі", source: "Өнім туралы ақпарат: qazaqnet.kz", top: "Жоғарыға" },
};

const dict = { ru, kz };
const LangCtx = createContext({ lang: "ru", t: ru, setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("bqi-lang") || "ru");
  useEffect(() => {
    localStorage.setItem("bqi-lang", lang);
    document.documentElement.lang = lang === "kz" ? "kk" : "ru";
  }, [lang]);
  return createElement(LangCtx.Provider, { value: { lang, setLang, t: dict[lang] || ru } }, children);
};

export const useLang = () => useContext(LangCtx);
